import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\">\n  <div class=\"columns small-12\">\n  </div>\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/page-state-cc-module",
  "version": "1.0.1",
  "id": "pageStateCcModule",
  "containerID": "sbCreditCardsPageStateCcModule",
  "moduleName": "sb-credit-cards-page-state-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "page-state-cc-module",
  "data": {
    "init": "pageStateCcModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class PageStateCcModule
 * @extends {Module}
 */
class PageStateCcModule extends Module {
  /**
   * Creates an instance of PageStateCcModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof PageStateCcModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: PageStateCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PageStateCcModule as default, moduleConfig };
